// Global audio context - shared across all sound plays
let audioContext = null;

// Initialize audio context with user interaction
const initAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  
  // Resume context if suspended (required by browser autoplay policies)
  if (audioContext.state === 'suspended') {
    audioContext.resume().catch(() => {});
  }
  
  return audioContext;
};

// Play a simple beep sound
export const playNotificationSound = () => {
  try {
    const ctx = initAudioContext();
    const now = ctx.currentTime;
    
    // Create oscillator
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    
    osc.connect(gain);
    gain.connect(ctx.destination);
    
    // Settings
    osc.frequency.value = 800;
    osc.type = 'sine';
    
    // Audible volume
    gain.gain.setValueAtTime(0.5, now);
    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
    
    osc.start(now);
    osc.stop(now + 0.5);
    
  } catch (error) {
    // Silent fail in production
  }
};

// Play a more musical notification sound (two beeps)
export const playNotificationSoundDouble = () => {
  try {
    const ctx = initAudioContext();
    const now = ctx.currentTime;
    
    // First beep - lower pitch
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    osc1.frequency.value = 800;
    osc1.type = 'sine';
    gain1.gain.setValueAtTime(0.5, now);
    gain1.gain.exponentialRampToValueAtTime(0.01, now + 0.25);
    osc1.start(now);
    osc1.stop(now + 0.25);
    
    // Second beep - higher pitch, starts after first ends
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    osc2.frequency.value = 1200;
    osc2.type = 'sine';
    gain2.gain.setValueAtTime(0.5, now + 0.3);
    gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.55);
    osc2.start(now + 0.3);
    osc2.stop(now + 0.55);
    
  } catch (error) {
    // Silent fail in production
  }
};

// Fallback: Use browser notification with sound
export const playNotificationWithBrowserAPI = (title = 'New Notification') => {
  if ('Notification' in window) {
    try {
      // Request permission if not granted
      if (Notification.permission === 'granted') {
        new Notification(title, {
          icon: '/favicon.ico',
          badge: '/favicon.ico',
          tag: 'notification',
          requireInteraction: false,
        });
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            new Notification(title);
          }
        });
      }
    } catch (error) {
      // Silent fail in production
    }
  }
};
